import { Moon, Palette, Sun } from '@orgus/ui/icons';
import { AppearancePicker, IconButton, Popover, PopoverContent, PopoverTrigger } from '@orgus/ui';
import { usePrefs } from '../../lib/prefs.ts';

/** The rail's appearance control: light, dark or system, in one small panel. */
export function AppearanceMenu({ side = 'top' }: { side?: 'top' | 'right' }) {
  const mode = usePrefs((s) => s.mode);
  const theme = usePrefs((s) => s.theme);
  const setMode = usePrefs((s) => s.setMode);
  const Icon = mode === 'system' ? Palette : theme === 'light' ? Sun : Moon;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <IconButton label="Appearance" icon={<Icon />} tooltipSide={side} />
      </PopoverTrigger>
      <PopoverContent side={side} align="start" className="w-auto p-3" aria-label="Appearance">
        <p className="pb-3 text-caption font-medium text-fg-subtle">Appearance</p>
        <AppearancePicker mode={mode} onMode={setMode} />
      </PopoverContent>
    </Popover>
  );
}
